<template>
  <div>
    <table-component :dataColumn="dataColumn">
      <template v-slot:header>
        <table-header :title="'ID'" :minWidth="50" />
        <table-header :title="$t('user.osName')" :minWidth="150" />
        <table-header :title="$t('user.ipAddress')" :minWidth="150" />
        <table-header :title="$t('user.timeDate')" :minWidth="150" />
        <table-header :title="$t('user.screen')" :minWidth="180" />
        <table-header :title="$t('user.operate')" :minWidth="100" />
        <table-header :title="$t('user.detail')" :minWidth="80" :width="50" />
      </template>

      <template v-slot:body="{ rowData: row, index }">
        <table-cell>{{ index + 1 + (currentPage - 1) * LIMIT }}</table-cell>
        <table-cell>{{ row.browserOs }}</table-cell>
        <table-cell>{{ row.ipDevice }}</table-cell>
        <table-cell>{{ getFullDate(row.createdAt) }}</table-cell>
        <table-cell>{{ checkScreen(row) }}</table-cell>
        <table-cell>{{ ESearchHistory.getTitle(row.actionType) }}</table-cell>
        <table-cell>
          <i
            :class="{ 'el-icon-view icon': row.productId || row.categoryId }"
            @click="handleViewDetail(row)"
          />
        </table-cell>
      </template>
    </table-component>

    <span v-if="idSelected">
      <master-data-detail
        :categoryObj="categoryDetail"
        :openMasterData="open.masterData"
        @handleCloseMasterData="handleCloseMasterData"
      />

      <product-detail
        :product="productDetail"
        :openProduct="open.product"
        @handleCloseProductDetail="handleCloseProductDetail"
      />
    </span>
  </div>
</template>

<script>
import { ESearchHistory } from '@/enums/user';
import { LIMIT } from '@/constants/common';
import { getFullDate } from '@/helper';
import { mapActions, mapGetters } from 'vuex';

const MasterDataDetail = () => import('../MasterDataDetail');
const ProductDetail = () => import('../ProductDetail');

export default {
  name: 'TableListHistory',
  components: { MasterDataDetail, ProductDetail },
  props: {
    dataColumn: Array,
    currentPage: Number,
  },
  data() {
    return {
      ESearchHistory,
      LIMIT,
      open: {
        product: false,
        masterData: false,
      },
      idSelected: undefined,
    };
  },
  computed: {
    ...mapGetters('category', ['categoryDetail']),
    ...mapGetters('product', ['productDetail']),
  },
  methods: {
    getFullDate,
    ...mapActions('category', ['getCategoryDetail']),
    ...mapActions('product', ['getHistoryDetail']),
    checkScreen(screen) {
      if (screen.productId) {
        return this.$t('user.productManagement');
      }

      if (screen.categoryId) {
        return this.$t('user.masterDataManagement');
      }

      return '';
    },
    handleViewDetail(row) {
      if (row.productId) {
        this.idSelected = row.productId;
        this.getHistoryDetail({ id: row.productId });
        this.open.product = true;
      }

      if (row.categoryId) {
        this.idSelected = row.categoryId;
        this.getCategoryDetail({ categoryId: row.categoryId });
        this.open.masterData = true;
      }
    },
    handleCloseMasterData() {
      this.open.masterData = false;
    },
    handleCloseProductDetail() {
      this.open.product = false;
    },
  },
};
</script>
